  import React from 'react';
import styled from 'styled-components';

const AutomationThing = styled.span`
  color: transparent;
  display: block;
  height: 0px;
`;

export const AutomationText = () => (
  <AutomationThing>.</AutomationThing>
)